import React from 'react'
import PropTypes from 'prop-types'
//get all valid values from the IcoMoon list
import IcoMoonData from '../../styles/fonts/icon-font/selection.json'

const Icon = props => (
  <span
    className={`icon icon-${props.name} ` + (props.className || '')}
    aria-hidden='true'
    onClick={props.onClick}
  />
)
Icon.propTypes = {
  name: PropTypes.oneOf(
    IcoMoonData.icons.map(iconObj => iconObj.properties.name)
  ),
  onClick: PropTypes.func,
  className: PropTypes.string
}

export default Icon



// WEBPACK FOOTER //
// ./src/ui/icons/icon.js